;
define("landing_page.tpl", function(){});

